/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { AgroClimaticZone } from '../../models/agro-climatic-zone';

export interface SaveAgroClimaticZone$Params {
   body: AgroClimaticZone;
}

export function saveAgroClimaticZone(
   http: HttpClient,
   rootUrl: string,
   params: SaveAgroClimaticZone$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<AgroClimaticZone>> {
   const rb = new RequestBuilder(rootUrl, saveAgroClimaticZone.PATH, 'post');
   if (params) {
      rb.body(params.body, 'application/json');
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<AgroClimaticZone>;
      })
   );
}

saveAgroClimaticZone.PATH = '/api/weather/agro/climatic/zone';
